import { interpret } from 'xstate';

import { createErrorMachine, createError } from '../machines/error';

/**
* Generic error handler for the fb-tool. When an event is sent to this service, a message will be displayed in a toast while the event is relayed to Sentry for further inspection
*/
const errorService = interpret(createErrorMachine('fb-tool-errors'), { devTools: true }).start();

/**
* Simple expression creator to be used in machines/services. This returns the error id back to the caller in case the user would like to
* see the error id for better debugging purposes
*/
const sendErrorService = (error: Error, subject?: string, data?: any): string => {
  const errorEvent = createError(error, subject, data);
  errorService.send(createError(error, subject, data));

  return errorEvent.id;
};

export {
  errorService,
  sendErrorService,
  createError,
};
